import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faUserCheck,
  faUndo,
  faCertificate,
  faFileAlt,
  faGavel,
  faPhone,
  faEnvelope,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";


const ANPC = () => {
  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
    


                     <div className='tittle-ab-top'>
                        <h4>Protectia Consumatorului - ANPC</h4>
                    </div>
           
                   
           
                {/* Introducere ANPC */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce este ANPC?</h4>
    <p>
      Autoritatea Nationala pentru Protectia Consumatorilor (ANPC) este institutia publica din Romania care 
      asigura protectia drepturilor consumatorilor si supravegheaza piata in ceea ce priveste siguranta produselor si serviciilor.
    </p>
    <p>
      ContaLearn respecta legislatia privind protectia consumatorilor si se angajeaza sa ofere servicii educationale 
      conforme cu standardele legale romanesti.
    </p>
    <p><strong>Legislatie aplicabila:</strong> Legea nr. 296/2004 privind Codul Consumului (actualizata)</p>
  </div>
</section>

{/* Drepturile consumatorilor */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturile consumatorilor conform Legii 296/2004</h4>
    <p>
      Ca utilizator al platformei ContaLearn, beneficiezi de urmatoarele drepturi fundamentale:
    </p>
    <ul style={{marginTop: '15px', listStyleType: 'none', paddingLeft: 0}}>
      <li style={{marginBottom: '10px'}}>
        <strong>🛡️ Dreptul la protectia sanatatii si securitatii</strong> — Serviciile sa nu puna in pericol viata, sanatatea sau securitatea
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>💰 Dreptul la protectia intereselor economice</strong> — Preturi corecte, fara clauze abuzive
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📋 Dreptul la informare</strong> — Informatii complete, corecte si precise despre servicii
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>📚 Dreptul la educatie pentru consum</strong> — Acces la informatii pentru alegeri in cunostinta de cauza
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>⚖️ Dreptul de a fi reprezentat si audiat</strong> — Posibilitatea de a-si exprima interesele
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>💳 Dreptul la despagubire</strong> — Compensatii pentru prejudicii cauzate de servicii neconforme
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🏛️ Dreptul de a se adresa justitiei</strong> — Acces la mecanisme de solutionare a litigiilor
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>🔄 Dreptul de retragere</strong> — Anularea contractului in termen de 14 zile (pentru contracte la distanta)
      </li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserCheck} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul de retragere */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUndo} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de retragere din contract (OUG 34/2014)</h4>
    <p>
      Pentru contractele incheiate la distanta (online), ai dreptul sa te retragi din contract in termen de 
      <strong> 14 zile calendaristice</strong>, fara a fi nevoie sa justifici decizia si fara penalitati.
    </p>
    <p><strong>Termenul de 14 zile incepe:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ De la data incheierii contractului pentru servicii digitale</li>
      <li>▸ De la data activarii abonamentului premium</li>
    </ul>
    <p><strong>Cum exerciti dreptul de retragere:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✓ Trimite o solicitare clara la <strong>contact@contalearn.ro</strong></li>
      <li>✓ Mentioneaza in email: "Solicitare de retragere din contract"</li>
      <li>✓ Include datele de identificare (nume, email, data achizitie)</li>
    </ul>
    <p><strong>Rambursare:</strong></p>
    <p>
      Vom rambursa suma platita in termen de <strong>14 zile</strong> de la primirea solicitarii de retragere, 
      folosind aceeasi metoda de plata utilizata initial, cu conditia sa nu fi fost accesat si finalizat niciun modul complet al cursului.
    </p>
    <div style={{background: '#fff3cd', padding: '15px', borderRadius: '10px', marginTop: '15px', border: '2px solid #ffc107'}}>
      <p style={{margin: 0}}><strong>⚠️ Exceptie:</strong> Dreptul de retragere nu se aplica pentru serviciile digital-educationale 
      deja prestate integral cu acordul explicit al consumatorului.</p>
    </div>
  </div>
</section>

{/* Garantie si conformitate */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Garantia si conformitatea serviciilor</h4>
    <p>
      Serviciile educationale oferite de ContaLearn trebuie sa fie conforme cu descrierea prezentata si 
      sa corespunda scopului pentru care sunt utilizate in mod normal.
    </p>
    <p><strong>Ce inseamna "lipsa de conformitate":</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Serviciul nu corespunde descrierii din prezentarea initiala</li>
      <li>▸ Functionalitatile promise nu sunt disponibile</li>
      <li>▸ Continutul este incomplet sau incorect in mod semnificativ</li>
      <li>▸ Platforma nu functioneaza conform specificatiilor tehnice</li>
    </ul>
    <p><strong>Drepturile tale in caz de neconformitate:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✓ Solicitarea remedierii neconformitatii</li>
      <li>✓ Reducerea proportionala a pretului</li>
      <li>✓ Rezolutiunea contractului cu rambursarea integrala</li>
    </ul>
    <p>
      Pentru sesizarea unei neconformitati, contacteaza-ne la <strong>contact@contalearn.ro</strong> cu descrierea detaliata a problemei.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCertificate} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Clauze abuzive */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faExclamationCircle} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Protectie impotriva clauzelor abuzive</h4>
    <p>
      Conform legislatiei privind protectia consumatorilor, clauzele contractuale abuzive sunt interzise si considerate nule.
    </p>
    <p><strong>Exemple de clauze abuzive (conform Legii 296/2004):</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✗ Excluderea sau limitarea raspunderii pentru vatamari corporale</li>
      <li>✗ Limitarea nejustificata a dreptului de reziliere</li>
      <li>✗ Prelungirea automata a contractului fara notificare prealabila</li>
      <li>✗ Modificarea unilaterala a pretului fara drept de retragere</li>
      <li>✗ Obligarea consumatorului la plata unor servicii nesolicitate</li>
    </ul>
    <p><strong>Angajamentul ContaLearn:</strong></p>
    <p>
      Ne angajam sa utilizam termeni contractuali transparenti, echitabili si conformi cu legislatia romana. 
      Orice clauza considerata abuziva poate fi contestata si este nula de drept.
    </p>
  </div>
</section>

{/* Cum depui o reclamatie */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cum depui o reclamatie la ANPC?</h4>
    <p>
      Daca consideri ca drepturile tale ca si consumator au fost incalcate, poti depune o reclamatie la ANPC prin:
    </p>
    
    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>1️⃣ Online - Platforma SOL (Solutionarea Online a Litigiilor)</h5>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>🌐 Acceseaza: <a href='https://ec.europa.eu/consumers/odr' target='_blank' rel='noopener noreferrer'>ec.europa.eu/consumers/odr</a></li>
      <li>📝 Completeaza formularul de reclamatie</li>
      <li>📧 Primesti notificari prin email despre stadiul solutionarii</li>
    </ul>

    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>2️⃣ Prin email sau posta</h5>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>📧 Email: <strong>office@anpc.ro</strong></li>
      <li>📬 Adresa: B-dul Aviatorilor nr. 72, Sector 1, Bucuresti, cod postal 011865</li>
    </ul>

    <h5 style={{color: '#13b8ab', marginTop: '20px'}}>3️⃣ La sediul ANPC sau comisariatele judetene</h5>
    <p>Poti depune reclamatia personal la oricare dintre comisariatele judetene ANPC.</p>

    <p style={{marginTop: '20px'}}><strong>Ce trebuie sa contina reclamatia:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Datele tale de identificare (nume, adresa, telefon, email)</li>
      <li>▸ Datele operatorului economic (ContaLearn)</li>
      <li>▸ Descrierea detaliata a problemei</li>
      <li>▸ Dovezi (capturi ecran, email-uri, chitante, contracte)</li>
      <li>▸ Solicitarile tale concrete</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Solutionarea Alternativa a Litigiilor */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGavel} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Solutionarea Alternativa a Litigiilor (SAL)</h4>
    <p>
      Conform Legii 192/2006, poti apela la proceduri alternative de solutionare a litigiilor cu consumatorii:
    </p>
    
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h5 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🇪🇺 Platforma SOL (Online Dispute Resolution)</h5>
      <p style={{margin: '5px 0'}}>Platforma europeana pentru solutionarea online a litigiilor</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Link:</strong> <a href='https://ec.europa.eu/consumers/odr' target='_blank' rel='noopener noreferrer'>ec.europa.eu/consumers/odr</a></p>
      <p style={{margin: '5px 0'}}>Aceasta platforma faciliteaza rezolvarea extrajudiciara a litigiilor intre consumatori si comercianti din UE.</p>
    </div>

    <p style={{marginTop: '20px'}}><strong>Avantajele SAL:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✓ Procedura mai rapida decat instanta</li>
      <li>✓ Costuri reduse sau inexistente</li>
      <li>✓ Confidentialitate</li>
      <li>✓ Solutii consensuale</li>
    </ul>

    <p style={{marginTop: '15px'}}>
      <strong>Important:</strong> Utilizarea SAL nu te impiedica sa apelezi ulterior la instantele judecatoresti daca nu esti multumit de rezultat.
    </p>
  </div>
</section>

{/* Contact ANPC */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact ANPC</h4>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <h5 style={{margin: '0 0 10px 0', color: '#13b8ab'}}>🏛️ Autoritatea Nationala pentru Protectia Consumatorilor</h5>
      <p style={{margin: '5px 0'}}><strong>📍 Adresa:</strong> B-dul Aviatorilor nr. 72, Sector 1, Bucuresti, cod postal 011865</p>
      <p style={{margin: '5px 0'}}><strong>📞 Telefon:</strong> 021.9551 (Luni - Vineri: 08:00 - 20:00)</p>
      <p style={{margin: '5px 0'}}><strong>📧 Email:</strong> office@anpc.ro</p>
      <p style={{margin: '5px 0'}}><strong>🌐 Website:</strong> <a href='https://anpc.ro' target='_blank' rel='noopener noreferrer'>www.anpc.ro</a></p>
      <p style={{margin: '5px 0'}}><strong>📱 Tel Verde:</strong> 0800.080.999 (gratuit din orice retea)</p>
    </div>

    <p style={{marginTop: '20px'}}><strong>📍 Gaseste comisariatul judetean:</strong></p>
    <p>ANPC are comisariate in fiecare judet. Lista completa se gaseste pe: 
    <a href='https://anpc.ro/ce-face-anpc/oficii-teritoriale/' target='_blank' rel='noopener noreferrer'> anpc.ro/oficii-teritoriale</a></p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faPhone} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Contact ContaLearn */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Rezolvarea directa cu ContaLearn</h4>
    <p>
      Inainte de a depune o reclamatie la ANPC, te incurajam sa ne contactezi direct pentru a incerca sa rezolvam situatia rapid si amiabil.
    </p>
    <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
      <p style={{margin: '5px 0'}}><strong>📩 Email suport:</strong> contact@contalearn.ro</p>
      <p style={{margin: '5px 0'}}><strong>📝 Subiect:</strong> "Reclamatie consumator - [descriere scurta]"</p>
      <p style={{margin: '5px 0'}}><strong>⏱️ Timp de raspuns:</strong> Maximum 48 ore lucratoare</p>
    </div>
    <p style={{marginTop: '15px'}}>
      Suntem dedicati sa oferim servicii de calitate si sa rezolvam orice problema in cel mai scurt timp posibil. 
      Feedback-ul tau ne ajuta sa imbunatatim constant platforma.
    </p>
  </div>
</section>

           
            <div className='line-about'></div>
           
                 
           
                 </div>
               </div>
   
  );
};

export default ANPC;

